import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { DynamicHomepageService } from "src/app/services/dynamic-homepage.service";
import { Annnouncement } from "src/app/components/utility/utility-classes";
import { ConfirmChangesDialogComponent } from "../confirm-changes-dialog/confirm-changes-dialog.component";
import { Observable } from "rxjs";
import { ErrorHandlerDialogComponent } from "src/app/components/error-handler-dialog/error-handler-dialog.component";

@Component({
    selector: "app-announcement-editor",
    templateUrl: "./announcement-editor.component.html",
    styleUrls: ["./announcement-editor.component.scss"],
    standalone: false
})
export class AnnouncementEditorComponent {
  announcementForm: FormGroup;
  announcement: Annnouncement = new Annnouncement();
  constructor(
    public dialogRef: MatDialogRef<AnnouncementEditorComponent>,
    private dialog: MatDialog,
    private homepageService: DynamicHomepageService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data != null) {
      this.announcement = data;
    }
    this.announcementForm = new FormGroup({
      message: new FormControl(this.announcement.message, Validators.required),
      is_activated: new FormControl(
        this.announcement.is_activated,
        Validators.required
      ),
    });
  }

  updateAnnouncement() {
    this.homepageService.updateAnnouncement(this.announcement).subscribe({
      next: (response: any) => {
        this.dialogRef.close(response);
      },
      error: (error: any) => {
        this.dialog.open(ErrorHandlerDialogComponent, {
          data: {
            message:
              "Error saving Announcements </br>" + error.error == null
                ? error.message
                : error.error.message,
            status: error.error === null ? error.status : error.error.status,
          },
        });
      },
    });
  }

  closeEditor() {
    this.dialogRef.close();
  }

  onSubmit() {
    this.openConfirmationDialog().subscribe((response) => {
      if (response.save) {
        this.updateAnnouncement();
        this.closeEditor();
      }
    });
  }

  openConfirmationDialog(): Observable<any> {
    const dialogRef = this.dialog.open(ConfirmChangesDialogComponent, {
      disableClose: true,
      data: {
        sectionType: "Announcement",
        columnsToDisplay: [],
        toDelete: [],
        toCreate: [],
      },
    });
    return dialogRef.afterClosed();
  }
}
